import React, { useContext, useRef } from 'react';
import styled from 'styled-components';
import RoleProtected, { userRoles } from '../RoleProtected';
import Row from '../layout/Row';
import { useGlobalState } from '../stateProvider/StateProvider';
import Icon from './Icon';
import { HelpToolContext } from '../HelpToolTip';
import { useHoverTooltip } from '../HoverTooltip';

const TooltipEventAnchor = styled.div`
    position: relative;
    display: inline-block;
`
const Icons = styled(Icon)`
    opacity: 0.5;
    transition: all 0.3s;
    cursor: pointer;

    &: hover {
        opacity: 1;
    }
`

const TooltipHelper = ({ formName, name, tooltipText, ...props }) => {
    const {
        state: { help = {} },
    } = useGlobalState();

    // const { setHoverTip, updateHelp, removeHelp } = useContext(HelpToolContext);
    const context = useContext(HelpToolContext);
    const ttRef = useRef(null);

    const { showTooltip, hideTooltip } = useHoverTooltip();

    if (!context) return;

    const handleTooltipMove = (e) => {
        const el = ttRef.current;   
        if (!el) return;

        showTooltip({
            text: tipText,
            x: e.clientX,
            y: e.clientY,
            noWrap: false,
            wrap: 'pre-wrap',
            maxWidth: 300,
            trigger: ttRef.current
        });
    };

    const { updateHelp, removeHelp } = context;

    const formHelp = help[formName] || {};
    const tipText = tooltipText ?? formHelp[name];

    return formName ? (
        <Row>
            {tipText && (
                <TooltipEventAnchor
                    ref={ttRef}
                    onMouseMove={handleTooltipMove}
                    onMouseLeave={() => hideTooltip(ttRef.current)}                
                >
                    <Icons
                        icon='questionMark'
                        style={{ fontSize: '0.8em' }}
                    />
                </TooltipEventAnchor>
            )}
            <RoleProtected roles={[userRoles.technicalInterfaceMaven]}>
                <Icons
                    icon={formHelp[name] ? 'edit' : 'plus'}
                    style={{ fontSize: '0.8em' }}
                    onClick={() => updateHelp(formName, name)}
                />

                {formHelp[name] && (
                    <Icons
                        icon='minus'
                        style={{ fontSize: '0.8em' }}
                        onClick={() => removeHelp(formName, name)}
                    />
                )}
            </RoleProtected>
        </Row>
    ) : null;
}

export default TooltipHelper;
